import moment from 'moment';
import * as yup from 'yup';
import { DependentType } from '../../api/usePersonalInfoQuery';
import { dobValidation } from '../YourInfo/YourInfo.meta';

export interface FormDependent {
  id: string;
  firstName: string;
  dob: string;
  type: DependentType;
  isDependent: boolean;
}

export interface DependentsFormValues {
  dependents: FormDependent[];
}

export const NEW_DEPENDENT = {
  id: '',
  firstName: '',
  type: DependentType.Child,
  dob: '',
  isDependent: true,
};

export const DEPENDENT_NAME_MAP = {
  [DependentType.Child]: 'Child',
  [DependentType.Grandchild]: 'Grandchild',
  [DependentType.OtherDependent]: 'Other Dependent',
  [DependentType.Charity]: 'Charity',
  [DependentType.OtherBeneficiary]: 'Other Beneficiary',
};

export const DEPENDENT_TYPE_OPTIONS = [
  {
    value: DependentType.Child,
    label: DEPENDENT_NAME_MAP[DependentType.Child],
  },
  {
    value: DependentType.Grandchild,
    label: DEPENDENT_NAME_MAP[DependentType.Grandchild],
  },
  {
    value: DependentType.OtherDependent,
    label: DEPENDENT_NAME_MAP[DependentType.OtherDependent],
  },
  {
    value: DependentType.Charity,
    label: DEPENDENT_NAME_MAP[DependentType.Charity],
  },
  {
    value: DependentType.OtherBeneficiary,
    label: DEPENDENT_NAME_MAP[DependentType.OtherBeneficiary],
  },
];

export const DESCENDANTS = [DependentType.Child, DependentType.Grandchild];

export const BENEFICIARIES = [DependentType.Charity, DependentType.OtherBeneficiary];

export const dependentsValidation = yup.array().of(
  yup.object().shape({
    firstName: yup.string().required('First name is required.'),

    dob: yup
      .string()
      .when('type', (type, schema) => {
        if (BENEFICIARIES.includes(type)) {
          return schema;
        }

        return schema.required('Date of birth is required');
      })
      .when('type', (type, schema) => {
        if (BENEFICIARIES.includes(type)) {
          return schema;
        }

        return dobValidation;
      }),
  }),
);

export interface DependentToUpdate {
  index: number;
  type: DependentType;
  newType: DependentType;
}

export interface DependentToDelete {
  index: number;
}
